import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { getAvailableDisplays } from '@/services/get-available-displays'

export const AVAILABLE_DISPLAYS_QUERY = 'AVAILABLE_DISPLAYS'

export const useGetAvailableDisplays = () => {
  const query = useQuery(
    [AVAILABLE_DISPLAYS_QUERY],
    ({ signal }) => getAvailableDisplays({ signal }),
    {
      onError(e: any) {
        toast.error(
          'Ocorreu um erro ao pegar os equipamentos disponíveis: ' + e.message,
        )
      },
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  )

  return query
}
